import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';
import _ from 'lodash';

export default [
  function productDetails () {
    return {
      restrict: 'E',
      replace: false,
      scope: {
        name: '@',
        sizing: '&',
        description: '&'
      },
      template: require('./product-details.jade')(jadeLocals),
      link: (scope) => {
        scope.measurements = null;

        scope.$watch(() => scope.sizing(), (s) => {
          if (typeof s != 'object' || !s.sizes) return;

          if (s.sizes.length > 0) {
            let sizeKeys = Object.keys(s.sizes);
            let measurementKeys = Object.keys(s.sizes[sizeKeys[0]]);

            scope.measurements = {};
            _.forEach(measurementKeys, (key) => {
              if (key === 'size') return;
              scope.measurements[key] = key.replace('_', ' ');
            });
          }
        });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/store/product-details/product-details.dir.js